export class PuntoVisita {
    public idCompania: string;
    public idPunto: string;
    public nombrePunto: string;
    public pais: string;
    public direccion: string;
    public longitud: string;
    public latitud: string;
    public telefono: string;
    public email: string;
    public nombreContacto: string;
    public idZona: number;
    public idRuta: number;
    public estado: string;
    public descripcionRuta: string;
    public descripcionZona: string;

    public telefono_2: string;
    public email_2:string ;
    public nombreContacto_2:string;
}

 